import { HttpClient } from "@angular/common/http"
import { environment } from "src/environments/environment"
import { BaseService } from "./base.service"
import { Injectable } from "@angular/core"
import { ResponseJson } from "../models/models"


@Injectable({ providedIn: 'root' })
export class AppService extends BaseService {
  apiUrl = `${environment.apiUrl}/app`

  constructor(protected override http: HttpClient) {
    super(http)
  }

  getFollowUpNotifications() {
    return this.get<ResponseJson<any>>(this.apiUrl + '/followup-notifications');
  }

  getActivityFollowupNotifications() {
    return this.get<ResponseJson<any>>(this.apiUrl + '/activity-followup-notifications');
  }

  closeFollowUpNotification(followUpId: string){
    return this.post<ResponseJson<Boolean>>(this.apiUrl + '/close-followup-notification', { followUpId });
  }

  closeActivityFollowupNotification(activityFollowUpId: string){
    return this.post<ResponseJson<Boolean>>(this.apiUrl + '/close-activity-followup-notification', { activityFollowUpId: activityFollowUpId });
  }

  callFollowUpCustomer(followUpId: string) {
    return this.post<ResponseJson<Boolean>>(this.apiUrl + '/call-followup-customer', { followUpId });
  }
}
